import Vue from "vue";

const SET_LOADING = (state, value) => {
  state.loading = value;
};

const SET_IS_CUSTOMER_PAGE = (state, value) => {
  state.isCustomerPage = value;
};

const SET_ACCOUNTS = (state, accounts) => {
  state.accounts = accounts;
};

const SET_UNPROCESSED_EMAIL_COUNT = (state, { id, count }) => {
  const newCounts = {
    ...state.unprocessedEmailCounts,
    [id]: count,
  };
  Vue.set(state, "unprocessedEmailCounts", newCounts);
};

const SET_TEMPLATES = (state, templates) => {
  state.templates = templates;
};

const SET_PAGINATION = (state, pagination) => {
  state.pagination = {
    ...state.pagination,
    ...pagination,
  };
};

const SET_FILTER = (state, value) => {
  state.filter = value;
};

const SET_EMAILS = (state, { emails, pagination }) => {
  state.emails = emails;
  state.pagination = {
    ...state.pagination,
    ...pagination,
  };
};

const SET_SELECTED_ACCOUNT = (state, account) => {
  state.selectedAccount = account;
};

const SET_SELECTED_EMAILS = (state, emails) => {
  state.selectedEmails = emails;
};

const SET_ACCOUNT_STATE = (state, value) => {
  state.accountState = value;
};

const SET_SEND_STATE = (state, value) => {
  state.sendState = value;
};

const SET_MATCH_STATE = (state, value) => {
  state.matchState = value;
};

const SET_CREATE_EMAIL_CUSTOMER_ID = (state, value) => {
  state.createEmailCustomerId = value;
};

const SET_VIEW_STATE = (state, value) => {
  state.viewState = value;
};

export default {
  SET_LOADING,
  SET_IS_CUSTOMER_PAGE,
  SET_ACCOUNTS,
  SET_UNPROCESSED_EMAIL_COUNT,
  SET_TEMPLATES,
  SET_EMAILS,
  SET_PAGINATION,
  SET_FILTER,
  SET_SELECTED_ACCOUNT,
  SET_SELECTED_EMAILS,
  SET_ACCOUNT_STATE,
  SET_SEND_STATE,
  SET_MATCH_STATE,
  SET_CREATE_EMAIL_CUSTOMER_ID,
  SET_VIEW_STATE,
};
